import { useState, useEffect, useContext } from 'react';
import { config } from '../config'
import { User } from "oidc-client-ts"
import NotificationsContext from '../store/notifications-context'
import { getValidationMessagesModalContent } from '../components/Shared/helpers'
import { useAuth } from "react-oidc-context";

export const baseUrl = '/findaleague/api/LeagueRegistration/';

const useApi = () => {
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setloading] = useState(false);
    const auth = useAuth();

    const notificationsCtx = useContext(NotificationsContext);

    const fetchData = ({ url, method = 'GET', body = null, headers = null, popupError = false }) => {
        const user = getUser();
        const token = user?.access_token;

        headers = {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            ...headers
        }

        let init = {
            method: method,
            headers: headers,
        };

        if (body != null && method == 'POST') {
            init =
            {
                ...init,
                body: JSON.stringify(body)
            }
        }
        setloading(true);
        return fetch(
            baseUrl + url, init)
            .then((response) => {
                if (response.status === 401) {
                    auth.signinRedirect({
                        state: window.location.href,
                        extraQueryParams: { app_path: window.location.pathname }
                    });
                } else {
                    return response.json();
                }
            })
            .then((responseJson) => {
                if (responseJson.isSuccess) {
                    setResponse(responseJson.data);
                    return responseJson.data;
                } else {
                    if (popupError == true &&
                        responseJson.validationErrors != null &&
                        responseJson.validationErrors.length > 0) {
                        let validationModal = getValidationMessagesModalContent(responseJson.validationErrors);
                        notificationsCtx.showModal(validationModal);
                    } else {
                        setError(responseJson.validationErrors);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
                setError(err);
            }).finally(() => {
                setloading(false);
            });
    };

    function getUser() {
        const oidcStorage = localStorage.getItem(`oidc.user:${config.oidcConfig.authority}:${config.oidcConfig.client_id}`)
        if (!oidcStorage) {
            return null;
        }

        return User.fromStorageString(oidcStorage);
    }

    return { fetchData, response, loading, error, setResponse };
};

export default useApi;